import {useAppDispatch} from "../store/hook";
import {setUserSliceStatus} from "../store/user/slice";
import {useEffect} from "react";
import {checkUserAuth, fetchUserShipment} from "../store/user/thunks";
import {EUserStatus} from "../store/user/types";

function useCheckAuth() {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            dispatch(checkUserAuth())
                .unwrap()
                .then(() => {
                    dispatch(fetchUserShipment());
                })
                .catch(() => null);
        } else
            dispatch(setUserSliceStatus(EUserStatus.ERROR));
    }, [dispatch]);
}

export default useCheckAuth;
